import { httpSingleton } from '@/lib/http-client';

export const encryptService = {
	getEncryptedToken() {
		return httpSingleton.orchestrateRequest<string>({
			method: 'GET',
			url: '/advisory-service/api/v1/encrypt',
		});
	},
};
